const firebaseConfig = {
  apiKey: "AIzaSyC5JNH38m4L91aFOYDU03mV0iAUEehTarw",
  authDomain: "client-side-creative-agency.firebaseapp.com",
  databaseURL: "https://client-side-creative-agency.firebaseio.com",
  projectId: "client-side-creative-agency",
  storageBucket: "client-side-creative-agency.appspot.com",
  messagingSenderId: "767361541097",
  appId: "1:767361541097:web:a49a87b527702460796178"
};
export default firebaseConfig;